import { apiGet } from "@/lib/http/client";
import type { ExportJobSummaryResponse } from "@/types/api";

export async function fetchExportJobSummary(params: Record<string, unknown>) {
  return apiGet<ExportJobSummaryResponse>("/export-jobs/summary", params);
}
